// @ts-ignore
__webpack_public_path__ = window.__shell_webpack_public_path__ || '/';

// @ts-ignore
export default {}